import { GiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/GiveawaySection';
import { RewardWinners } from 'root/src/client/web/giveaway/features/RewardWinner/RewardWinners';
import { GiveawayStats } from 'root/src/client/web/giveaway/features/GiveawayStats/GiveawayStats';
import { GiveawayRewards } from 'root/src/client/web/giveaway/features/GiveawayRewards/GiveawayRewards';
import { CreatorDataInfo } from 'root/src/client/web/record/CreatorData/CreatorDataInfo';
import { useIsBetaTester } from 'root/src/client/logic/api/hooks/useCreatorData';
import { useCreatorLiveStream } from 'root/src/client/web/record/CreatorData/hooks/useCreatorLiveStream';
import { FloatingTwitchPlayer } from 'root/src/client/web/record/CreatorData/components/FloatingTwitchPlayer';
import { RelatedProfiles } from 'root/src/client/web/record/CreatorData/components/RelatedProfiles';
import { useRelatedProfiles } from 'root/src/client/web/record/CreatorData/hooks/useRelatedProfiles';
export const CreatorData = () => {
    const isBetaTester = useIsBetaTester();
    const { isLive, stream, channelName, settings } = useCreatorLiveStream();
    const relatedProfiles = useRelatedProfiles();
    return (<div className="flex flex-col" style={{ flex: 'initial', minHeight: 'initial !important' }}>
			{isLive && stream && channelName && settings && (<FloatingTwitchPlayer channelName={channelName} stream={stream} settings={settings}/>)}
			<div className="flex flex-col gap-4 w-full max-w-large xl:px-12 justify-center self-center">
				<div className="flex flex-col md:flex-row gap-4 px-4 xl:px-0">
					<div className="flex CreatorTile">
						<CreatorDataInfo />
					</div>
					{isBetaTester && (<div className="flex flex-initial w-full md:w-2/5">
							<GiveawaySection />
						</div>)}
				</div>
				{relatedProfiles.length > 0 && (<div className="px-4 xl:px-0">
						<RelatedProfiles profiles={relatedProfiles}/>
					</div>)}
				{isBetaTester && (<div className="px-4 xl:px-0 flex flex-col gap-4">
						<RewardWinners />
						<div className="beta flex flex-col md:flex-row gap-4 xl:px-0 md:items-start items-stretch w-full">
							<GiveawayStats />
						</div>
						<div className="mx-2">
							<GiveawayRewards />
						</div>
					</div>)}
			</div>
		</div>);
};
